const rutFormato = (rut) => {
  var rformato = "";
  var sDigito = "";
  var sValorFinal = "";
  var sDigVR = "";
  if (rut.length > 0) {
    rut = rut.replace("-", "").replace(".", "").replace(",", "");
    sDigito = rut.substring(0, rut.length - 1);
    //const rutF = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(sDigito) ' Le agrega el signo $
    const rutF = new Intl.NumberFormat("es-CL").format(sDigito);
    sDigVR = rut.substring(rut.length - 1);
    sValorFinal = rutF.replace("$", "") + "-" + sDigVR;
    rformato = sValorFinal;
  } else {
    rformato = rut;
  }
  return rformato;
};
const rutFormatoBaseDatos = (rut) => {
  var ColocarCeros = "";
  rut = rut.trim();
  if (rut.length > 0) {
    rut = rutSinFormato(rut);
    rut = rut.padStart(10, "0");
    ColocarCeros = rut;
  }
  return ColocarCeros;
};
const rutSinFormato = (rut) => {
  var ColocarCeros = "";
  rut = rut.trim();
  if (rut.length > 0) {
    rut = rut.replace("-", "");
    rut = rut.replaceAll(".", "");
    rut = rut.replaceAll(",", "");
    ColocarCeros = rut;
  }
  return ColocarCeros;
};

const rutValidar = (rut) => {
  var Digito = "";
  var Posicion = 0;
  var Acumula = 0;
  var Factor = 2;
  var RT = false;
  rut = rut.trim();
  if (rut.length > 0) {
    // Reemplazo formaro
    rut = rutSinFormato(rut);
    // Obtener el numero
    Digito = rut.substring(rut.length - 1);
    rut = rut.substring(0, rut.length - 1);
    // Obtener el dígito
    if (rut.length > 0) {
      while (Posicion <= rut.length - 1) {
        var Valor = parseInt(
          rut.substring(rut.length - 1 - Posicion, rut.length - Posicion)
        );
        Acumula = Acumula + Valor * Factor;
        Posicion = Posicion + 1;
        Factor = Factor + 1;
        if (Factor === 8) {
          Factor = 2;
        }
      }
      //Preparamos el resultado en Acumula
      Acumula = 11 - (Acumula % 11);

      //Hacemos el chequeo
      if (
        (Acumula === 10 && Digito.toUpperCase() === "K") ||
        (Acumula === 11 && Digito === "0") ||
        Acumula === parseInt(Digito)
      ) {
        RT = true;
      }
    }
  }
  return RT;
};

const persona = {
  rutFormato,
  rutFormatoBaseDatos,
  rutSinFormato,
  rutValidar,
};

export default persona;
